import { Component } from "reactn";
import React from "reactn";
import Spinner from "js/react/components/Spinner";

/**
 * @typedef {object} LoadableProps
 * @property {boolean} [isLoading=true]
 * @property {React.ReactNode} [children]
 */

/**
 * A component that displays a spinner while loading and its children when loaded.
 * @augments {React.Component<LoadableProps>}
 */
export default class Loadable extends Component {
    render() {
        let {
            isLoading = true,
        } = this.props;

        if (isLoading) {
            return <div style={{ minHeight: 100 }}><Spinner /></div>;
        } else {
            return this.props.children || null;
        }
    }
}
